﻿export var hasPopulatedPage = false;
export function modifyHasPopulatedPage(value) { hasPopulatedPage = value; }
export function getHasPopulatedPage() {
    return hasPopulatedPage;
}